<template>
	<section style="overflow-y: auto;height: calc(100vh - 105px);overflow-x: hidden;">
		<!--工具条-->
		<el-row>
			<el-col :span="24" class="toolbar">
				<el-form :inline="true" class="filterForm">
					<el-form-item label="统计时间:" label-width="100px">
						<el-date-picker type="daterange" v-model="statTimes" value-format="yyyy-MM-dd"
							class="formItem300" @change="loadMainCount" size="small"></el-date-picker>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<el-row :gutter="10" style="margin-left: 5px;overflow: hidden;">
			<el-col :span="24" style="padding-bottom: 0px;">
				<el-card class="box-card" style="height: 160px;">
					<div style="font-size:17px;font-weight:bold;">学习概括</div>
					<ul class="custMaincls">
						<li>
							<div class="title">学习人数</div>
							<div class="num">{{ mainCount.userCount }}</div>
						</li>
						<li style="width: 100px;">
							<div class="title">学习时长(小时)</div>
							<div class="num">{{ mainCount.timeCount }}</div>
						</li>
					</ul>
				</el-card>
			</el-col>
		</el-row>
		<!--列表-->
		<el-row :gutter="10" style="margin-left: 5px;" class="filterForm">
			<el-col :span="12" style="padding-bottom: 0px;">
				<div style="display: block; height: 45px;line-height: 45px;">
					<div style="float: left;">排行榜 </div>
					<div style="float: right;">
				<el-select v-model="filters.gradeId" placeholder="请选择年级" size="small" class="formItem200" @change="loadMainCount" clearable @clear="(v)=>{filters.gradeId='';this.loadMainCount()}">
							<el-option v-for="item in gradeDict" :key="item.id" :label="item.gradeName"
								:value="item.id">
							</el-option>
						</el-select>
						<el-button type="primary" v-on:click="expross('scorerankTable', '排行榜')"
							size="small">导出</el-button>
					</div>
				</div>
				<el-table ref="scorerankTable" :data="mainCount.scoreranklist" height="320px" border
					highlight-current-row style="width: 100%;">
					<el-table-column prop="indexNo" label="排名" width="65"></el-table-column>
					<el-table-column prop="realName" label="用户姓名" width="100" show-overflow-tooltip></el-table-column>
					<el-table-column prop="logName" label="用户名" width="100" show-overflow-tooltip></el-table-column>
					<el-table-column prop="mobileNo" label="手机号" width="130"></el-table-column>
					<el-table-column prop="schoolName" label="所属机构" width="160" show-overflow-tooltip></el-table-column>
					<el-table-column prop="className" label="班级名称" width="90" show-overflow-tooltip></el-table-column>
					<el-table-column prop="teacherName" label="所属老师" width="100" show-overflow-tooltip></el-table-column>
					<el-table-column prop="scoreNum" label="积分" min-width="90"></el-table-column>
				</el-table>
			</el-col>
			<el-col :span="12" style="padding-bottom: 0px;">
				<div style="display: block; height: 45px;line-height: 45px;">
					<div style="float: left;">错题榜 </div>
				<div style="float: right;">
						<el-button type="primary" v-on:click="expross('errorrankTable', '错题榜')"
							size="small">导出</el-button>
					</div>
				</div>
				<el-table ref="errorrankTable" :data="mainCount.errorranklist" height="320px" border
					highlight-current-row style="width: 100%;">
					<el-table-column prop="indexNo" label="排名" width="65"></el-table-column>
					<el-table-column prop="proTypeName" label="题目类型" width="80"></el-table-column>
					<el-table-column prop="proNo" label="题号" width="80"></el-table-column>
					<el-table-column prop="proName" label="题目" width="180" show-overflow-tooltip></el-table-column>
					<el-table-column prop="proLevelName" label="难度" min-width="80"></el-table-column>
					<el-table-column prop="gradeName" label="年级" width="100" show-overflow-tooltip></el-table-column>
					<el-table-column prop="unitName" label="单元" width="85" show-overflow-tooltip></el-table-column>
					<el-table-column prop="chapterName" label="章节" width="85" show-overflow-tooltip></el-table-column>
					<el-table-column prop="bookVersionName" label="教材版本" width="85" show-overflow-tooltip></el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row :gutter="10" style="margin-left: 5px;" class="filterForm">
			<el-col :span="12" style="padding-bottom: 0px;">
				<div style="display: block; height: 45px;line-height: 45px;">
					<div style="float: left;">机构榜</div>
					<div style="float: right;">
						<el-button type="primary" v-on:click="expross('schoolrankTable', '机构榜')"
							size="small">导出</el-button>
					</div>
				</div>

				<el-table ref="schoolrankTable" :data="mainCount.schoolranklist" height="320px" border highlight-current-row
					style="width: 100%;">
					<el-table-column prop="indexNo" label="排名" width="65"></el-table-column>
					<el-table-column prop="schoolName" label="机构名称" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="userNum" label="人数" min-width="90"></el-table-column>
					<el-table-column prop="scoreNum" label="积分" min-width="90"></el-table-column>
					<el-table-column prop="avgScoreNum" label="均分" min-width="90"></el-table-column>
				</el-table>
			</el-col>
			<el-col :span="12" style="padding-bottom: 0px;">
				<div style="display: block; height: 45px;line-height: 45px;">
					<div style="float: left;">班级榜</div>
					<div style="float: right;">
						<el-button type="primary" v-on:click="expross('classrankTable', '班级榜')"
							size="small">导出</el-button>
					</div>
				</div>
				<el-table ref="classrankTable" :data="mainCount.classranklist" height="320px" border highlight-current-row
					style="width: 100%;">
					<el-table-column prop="indexNo" label="排名" width="65"></el-table-column>
					<el-table-column prop="className" label="班级名称" width="200" show-overflow-tooltip></el-table-column>
					<el-table-column prop="schoolName" label="所属机构" width="200" show-overflow-tooltip></el-table-column>
					<el-table-column prop="userNum" label="人数" min-width="90"></el-table-column>
					<el-table-column prop="scoreNum" label="积分" min-width="90"></el-table-column>
					<el-table-column prop="avgScoreNum" label="均分" min-width="90"></el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row :gutter="10" style="margin-left: 5px;" class="filterForm">
			<el-col :span="12" style="padding-bottom: 0px;">
				<div style="display: block; height: 45px;line-height: 45px;">
					<div style="float: left;">年级榜</div>
					<div style="float: right;">
						<el-button type="primary" v-on:click="expross('graderankTable', '年级榜')"
							size="small">导出</el-button>
					</div>
				</div>
				<el-table ref="graderankTable" :data="mainCount.graderanklist" height="320px" border highlight-current-row
					style="width: 100%;">
					<el-table-column prop="indexNo" label="排名" width="65"></el-table-column>
					<el-table-column prop="gradeName" label="年级名称" width="200"
						show-overflow-tooltip></el-table-column>
				<el-table-column prop="userNum" label="人数" min-width="90"></el-table-column>
					<el-table-column prop="scoreNum" label="积分" min-width="90"></el-table-column>
					<el-table-column prop="avgScoreNum" label="均分" min-width="90"></el-table-column>
				</el-table>
			</el-col>
			<el-col :span="12" style="padding-bottom: 0px;">
				<div style="display: block; height: 45px;line-height: 45px;">
					<div style="float: left;">教师榜</div>
					<div style="float: right;">
						<el-button type="primary" v-on:click="expross('teacherrankTable', '教师榜')"
							size="small">导出</el-button>
					</div>
				</div>
				<el-table ref="teacherrankTable" :data="mainCount.teacherranklist" height="320px" border highlight-current-row
					style="width: 100%;">
					<el-table-column prop="indexNo" label="排名" width="65"></el-table-column>
					<el-table-column prop="teacherName" label="教师名称" width="200"
						show-overflow-tooltip></el-table-column>
			<el-table-column prop="userNum" label="人数" min-width="90"></el-table-column>
					<el-table-column prop="scoreNum" label="积分" min-width="90"></el-table-column>
					<el-table-column prop="avgScoreNum" label="均分" min-width="90"></el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<div>&nbsp;</div>
		<div>&nbsp;</div>
		<div>&nbsp;</div>
	</section>
</template>
<script>
export default {
	data() {
		return {
			statTimes: [],
			filters: {
				"statTime": '',
				"statTime2": '',
				gradeId:''
			},
			mainCount: {
				"userCount": 0,
				"timeCount": 0,
				scoreranklist: [],
				errorranklist: [],
				schoolranklist: [],
				classranklist: [],
				teacherranklist: [],
				graderanklist:[]
			},
			gradeDict:[]
		}
	},
	methods: {
		expross(tableId, title) {
			this.publicHandleExport(tableId, title);
		},
		async loadMainCount() {
			this.$util.dealQueryDateRange(this.filters, this.statTimes, "statTime")
			this.mainCount = (await this.$axios.get("/school/getStat_studyCount?startTime=" + this.filters.statTime + "&endTime=" + this.filters.statTime2 + "&gradeId="+this.filters.gradeId+"&rnd=" + new Date().getTime())).data.data;
			this.getList()
		},
		getList() {
			this.mainCount.scoreranklist.map((item, idx) => {
				this.$set(item, "indexNo", "" + (idx + 1))
			})
			this.mainCount.errorranklist.map((item, idx) => {
				this.$set(item, "indexNo", "" + (idx + 1))
			})
			this.mainCount.schoolranklist.map((item, idx) => {
				this.$set(item, "indexNo", "" + (idx + 1))
			})
			this.mainCount.classranklist.map((item, idx) => {
				this.$set(item, "indexNo", "" + (idx + 1))
			})
			this.mainCount.teacherranklist.map((item, idx) => {
				this.$set(item, "indexNo", "" + (idx + 1))
			})
			this.mainCount.graderanklist.map((item, idx) => {
				this.$set(item, "indexNo", "" + (idx + 1))
			})
		},
		async loadGrade() {
			let formData = this.$util.jsonToForm({
				rows: 1000,
				page: 1
			});
			this.$axios.post("/basic/getgradeinfolist", formData).then(res => {
				this.gradeDict = res.data.data;
			});
		},

	},
	async created() {
		this.loadGrade()
	},
	async mounted() {
		this.loadMainCount();
	}
}

</script>
<style scoped lang="scss">
.el-card__body {
	padding: 5px !important;
	height: 160px;
}

.custMaincls {
	list-style-type: none;
	margin: 0;
	margin-top: 25px;
	padding: 0;
	display: flex;

	/* 使用Flex布局 */
	li {
		margin-right: 10px;
		/* 可选，为元素之间增加间隔 */
		width: 80px;
		border-right: 1px solid #ccc;

		.title {
			font-size: 14px;
			text-align: center;
		}

		.num {
			margin-top: 10px;
			font-size: 14px;
			font-weight: bold;
			text-align: center;
		}
	}
}

.echart-pie {
	width: 330px;
	height: 130px;
	border: 0px solid pink;
	margin: 0px auto;
	padding: 0;
}
</style>
